<template>
    <div class="row gy-2">
        <div class="col-12">
            <h5 class="mb-3">List of Your Allowances</h5>
            <div class="row mb-3 gy-2 justify-content-between">
                <div class="col-md-6 col-lg-5 d-flex">
                    <div class="input-group w-auto">
                        <b-form-select style="max-width:100px;" class="form-select" v-model="itemsPerPage"
                            :options="pageOptions"></b-form-select>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="input-group mb-0">
                        <input v-model="searchQuery" @input="updateSearchQuery" type="search" class="form-control"
                            placeholder="Search here..." aria-label="Search here..."
                            aria-describedby="button-search_TB">
                        <button @click="fetchItems()" class="btn btn-primary" type="button" id="button-search_TB"><span
                                class="ri ri-search-line"></span></button>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <p class="mb-0">Showing {{ paginationInfo }} results</p>
            </div>
            <div class="card">
                <div class="card-body p-3">
                    <div class="table-responsive mb-0 loading-viewport">
                        <CommonSpinner v-if="isLoading" :box="true" />
                        <b-table striped hover ref="selectableTable" :items="pageData.data" :fields="columns"
                            responsive="sm" align="middle">
                            <template v-for="(column, colIndex) in columns.filter((i) => i.sortable)"
                                v-slot:[`head(${column.key})`]>
                                <div :key="colIndex" @click="setSortOrder(column)" class="cursor-pointer
                                    d-flex align-items-center">
                                    {{ column.label }} <span v-html="getSortingLabel(column.key)"></span>
                                </div>
                            </template>
                            <template v-for="(column, colIndex) in columns.filter((i) => i.auto)"
                                v-slot:[`cell(${column.key})`]="data">
                                <div @click="navigateTo(data.item)" :key="colIndex"
                                    :style="{ 'width': `${column.width || '7'}rem` }"
                                    class="cursor-pointer d-flex align-items-center">
                                    <CommonTableTemplate :item="data.item" :column="column" />
                                </div>
                            </template>
                            <template v-slot:cell(category_title)="data">
                                <div style="min-width:12rem;" @click="navigateTo(data.item)">
                                    {{ data.item.category_title }}

                                    <div v-if="data.item.allowance_amount_type == 'percentage'">
                                    <small>({{ `${data.item.allowance_amount}% of ₦${$filters.number_format(data.item.step_level_basic_salary, 2)}` }})</small></div>
                                </div>
                            </template>
                            <template v-slot:cell(allowance_amount)="data">
                                <div style="min-width:8rem;" @click="navigateTo(data.item)">
                                    <p v-if="data.item.allowance_amount_type == 'percentage'" class="mb-0"
                                            v-b-tooltip.hover :title="`${data.item.allowance_amount}% of ₦${$filters.number_format(data.item.step_level_basic_salary, 2)}`"
                                    >{{ $filters.number_format(data.item.evaluated_amount,2) }}</p>
                                    <p v-else class="mb-0">{{ $filters.number_format(data.item.allowance_amount, 2) }}</p>
                                </div>
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
            <div class="mb-4">
                <b-pagination v-model="currentPage" :limit="pageLimit" class="pagination-rounded"
                    :total-rows="pageData.total" :per-page="itemsPerPage"></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import { commonSortingMixin } from '@shared/mixins/commonSortingMixin';
import { commonPaginationMixin } from '@shared/mixins/commonPaginationMixin';

export default {
    name: "allowance-list",
    mixins: [
        commonSortingMixin,
        commonPaginationMixin,
    ],
    data() {
        return {
            isLoading: false,

            searchQuery: "",
            columns: [
                { key: "check" },
                { key: "category_title", width:12, auto: false, label: "Allowance" },
                { key: "allowance_amount", auto: false, label: "Amount (₦)", sortable: true },
                { key: "allowance_amount_type", auto: true, label: "Amount Type", sortable: true },
                { key: "created_at", auto: true, label: "Created at", sortable: true },
            ],
            sortBy: {
                sort_column: "created_at",
                sort_direction: "asc"
            },
            pageData: {
                data: []
            },
        }
    },
    methods: {
        navigateTo(item) {
        },
        updateSearchQuery: _.debounce(function (string) {
            this.fetchItems()
        }, 2000),
        fetchItems(page, per_page = null) {
            let payload = {
                page: page || 1, per_page: per_page || this.itemsPerPage,
                ...this.sortBy
            }
            if (this.searchQuery) { payload.search = this.searchQuery }

            this.isLoading = true
            this.$http.get(`/allowances?${new URLSearchParams(payload).toString()}`)
                .then((response) => {
                    this.isLoading = false
                    if (response.data.success) {
                        this.pageData = response.data.data
                        this.initializeAll();
                    }
                })
        },
        initializeAll() {
        },
    },
    created() {
        this.fetchItems()
    },
}

</script>
